import { cn } from "@/lib/utils";

/**
 * Tasdiqlangan shaxs belgisi (PRD §12, 3-daraja).
 *
 * NEGA INLINE SVG, ikonka kutubxonasidan emas: bu belgi platformaning
 * "bu odam haqiqatan o'sha" degan kafolati, va uning shakli
 * kutubxonaning keyingi versiyasida o'zgarib ketmasligi kerak.
 *
 * Rang `currentColor` EMAS, qat'iy ko'k: belgi qaerda turishidan
 * qat'i nazar bir xil ko'rinishi kerak — matn rangiga qo'shilib
 * ketgan tasdiq belgisi tasdiq belgisi emas, bezak bo'lib qoladi.
 */
export function VerifiedBadge({ className, title }: { className?: string; title?: string }) {
  return (
    <svg
      aria-label={title ?? "Verified"}
      role="img"
      viewBox="0 0 40 40"
      className={cn("inline-block size-4 shrink-0 align-[-2px]", className)}
      fill="rgb(0, 149, 246)"
    >
      <title>{title ?? "Verified"}</title>
      <path
        d="M19.998 3.094 14.638 0l-2.972 5.15H5.432v6.354L0 14.64 3.094 20 0 25.359l5.432 3.137v5.905h5.975L14.638 40l5.36-3.094L25.358 40l3.232-5.6h6.162v-6.01L40 25.359 36.905 20 40 14.641l-5.248-3.03v-6.46h-6.419L25.358 0l-5.36 3.094Zm7.415 11.225 2.254 2.287-11.43 11.5-6.835-6.93 2.244-2.258 4.587 4.581 9.18-9.18Z"
        fillRule="evenodd"
      />
    </svg>
  );
}
